import React, {useMemo} from 'react'
import {ObjectState} from 'types'

interface CircularProgressBarProps {
  gradientStart: string
  gradientStop?: string
  width: number
  strokeWidth: number
  strokeColor: string
  stateProgress: ObjectState<number>
}

export default function CircularProgressBar({
  gradientStart,
  gradientStop,
  width = 100,
  strokeWidth = 15,
  strokeColor,
  stateProgress,
}: CircularProgressBarProps) {
  const prog = stateProgress[0]
  const radius = (width - strokeWidth) / 2
  const circumference = radius * Math.PI * 2
  const dash = (prog * circumference) / 100
  const handleRenderProgress = useMemo(
    () => (
      <svg width={width} height={width} viewBox={`0 0 ${width} ${width}`}>
        <defs>
          <linearGradient id="gradient">
            <stop offset="0%" stopOpacity="1" stopColor={gradientStart} />
            <stop
              offset="100%"
              stopOpacity="1"
              stopColor={gradientStop || gradientStart}
            />
          </linearGradient>
        </defs>
        <circle
          strokeWidth={strokeWidth}
          r={radius}
          stroke={strokeColor}
          cx={width / 2}
          cy={width / 2}
          fill="none"
        />
        <circle
          width={width}
          height={width}
          strokeWidth={strokeWidth}
          r={radius}
          stroke="url(#gradient)"
          cx={width / 2}
          cy={width / 2}
          strokeDasharray={`${dash} ${circumference - dash}`}
          transform={`rotate(-90 ${width / 2} ${width / 2})`}
          strokeDashoffset={dash}
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    ),
    [
      circumference,
      dash,
      gradientStart,
      gradientStop,
      radius,
      strokeColor,
      strokeWidth,
      width,
    ],
  )

  return <div>{handleRenderProgress}</div>
}
